import { render, staticRenderFns } from "./HintsSection.vue?vue&type=template&id=6ebb9d34&scoped=true"
import script from "./HintsSection.vue?vue&type=script&lang=js"
export * from "./HintsSection.vue?vue&type=script&lang=js"
import style0 from "./HintsSection.vue?vue&type=style&index=0&id=6ebb9d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebb9d34",
  null
  
)

export default component.exports